import { render, staticRenderFns } from "./company-in-brief.vue?vue&type=template&id=15c041d3&scoped=true"
import script from "./company-in-brief.vue?vue&type=script&lang=js"
export * from "./company-in-brief.vue?vue&type=script&lang=js"
import style0 from "./company-in-brief.vue?vue&type=style&index=0&id=15c041d3&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c041d3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15c041d3')) {
      api.createRecord('15c041d3', component.options)
    } else {
      api.reload('15c041d3', component.options)
    }
    module.hot.accept("./company-in-brief.vue?vue&type=template&id=15c041d3&scoped=true", function () {
      api.rerender('15c041d3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/supplier/sections/company-in-brief.vue"
export default component.exports